import { Link } from "react-router-dom";

function FooterLink({ name, to }) {
  return (
    <Link to={to}>
      <p className="font-poppins text-gray-300 text-[13px] leading-[23px] hover:text-theme_secondary_sm transition-all ease-in-out">
        {name}
      </p>
    </Link>
  );
}

export default FooterLink;
